/**
 * Flat map statusReportItemId -> item node (first occurrence wins).
 */
export function indexStatusReportItemsById (items, acc = new Map()) {
  if (!items?.length) return acc
  for (const item of items) {
    if (item?.statusReportItemId != null && !acc.has(item.statusReportItemId)) {
      acc.set(item.statusReportItemId, item)
    }
    indexStatusReportItemsById(item.items, acc)
  }
  return acc
}
